import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";

export function Navbar() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
    { to: "/blog", label: "Blog" },
    { to: "/sop", label: "For Teams" },
  ];

  const scrollToWizard = () => {
    if (location.pathname !== "/") {
      window.location.href = "/#wizard";
      return;
    }
    const el = document.getElementById("wizard");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav data-testid="navbar" className="fixed top-0 left-0 right-0 z-50 bg-[#09090b] border-b border-white/5">
      <div className="max-w-6xl mx-auto px-6 h-14 flex items-center justify-between">

        {/* Logo */}
        <Link to="/" data-testid="navbar-logo" className="flex items-center">
          <span className="text-white font-semibold tracking-tight text-lg">
            Yukti<span className="text-[#38bdf8]">.</span>
          </span>
        </Link>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-7">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              className={`text-sm font-medium transition-colors duration-150 ${location.pathname === link.to
                ? "text-white"
                : "text-zinc-500 hover:text-zinc-200"
                }`}
            >
              {link.label}
            </Link>
          ))}

          <button
            data-testid="nav-analyze-button"
            onClick={scrollToWizard}
            className="flat-btn-primary text-xs px-4 py-2 font-medium"
          >
            Analyze
            <ArrowRight className="w-3 h-3" />
          </button>
        </div>

        {/* Mobile toggle */}
        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden text-zinc-400 hover:text-white p-1.5 transition-colors"
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-[#18181b] border-b border-white/7 px-6 py-4 space-y-1"
        >
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              onClick={() => setMobileOpen(false)}
              className="block text-sm text-zinc-400 hover:text-white py-2.5 border-b border-white/5 last:border-none transition-colors duration-150"
            >
              {link.label}
            </Link>
          ))}
          <div className="pt-3">
            <button
              onClick={() => { setMobileOpen(false); scrollToWizard(); }}
              className="flat-btn-primary w-full justify-center"
            >
              Analyze My Business
              <ArrowRight className="w-3.5 h-3.5" />
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
